
interface MetaData {
    title: string;
    description: string;
    robots?: string;
    canonical?: string;
    og?: {
        locale?: string,
        type?: string,
        title?: string,
        description?: string,
        url?: string,
        site_name?: string,
        updated_time?: string,
        image?: string,
        image_secure_url?: string,
        image_width?: number,
        image_height?: number,
        image_alt?: string,
        image_type?: string,
        video?: string,
        video_duration?: number,
        video_upload_date?: string,
        video_allow_embed?: boolean,
    };
    twitter?: {
        card?: string,
        title?: string,
        description?: string,
        image?: string,
    };
}

interface Step {
    title: string;
    desc: string;
    icon: string;
}

interface ProcedureSteps {
    heading: string;
    para: string;
    steps: Step[];
}

interface ListItem {
    title: string;
    desc: string;
    icon: string;
}

interface ListSection {
    heading?: string;
    subheading?: string;
    para?: string;
    items: ListItem[];
}

interface ingredients {
    heading?: string;
    subheading?: string;
    para?: string;
    items: ListItem[];
}

interface FAQItem {
    question: string;
    answer: string;
}

interface FAQSection {
    heading?: string;
    subheading?: string;
    items: FAQItem[];
}

interface HeroSection {
    title: string;
    subtitle: string;
    description: string;
}

interface HowItWorks {
    title: string;
    description: string;
}

interface TreatmentArea {
    ar: string;
    title: string;
    image: string;
}

interface LanguageContent {
    url?: string; // Added url property
    meta: MetaData;
    breadcrumbs: string[];
    hero: HeroSection;
    howItWorks: HowItWorks;
    procedureSteps: ProcedureSteps;
    benefits: ListSection;
    eligibility: ListSection;
    preparationTips: ListSection;
    results: ListSection;
    // aftercareTips: ListSection;
    faqData: FAQSection;
    ingredients: ingredients;
    // treatmentAreas1: TreatmentArea[];
    // treatmentAreas2: TreatmentArea[];
}

interface SharedData {
    images: {
        main: string,
        beforeAfter: string[] | any,
        introductionImage?: string,
    };
    product: {
        id: number,
        title: string,
        price: number,
        description: string,
    };
}

export const femalebalance: {
    en: LanguageContent,
    ar: LanguageContent,
    shared: SharedData,
} =
{
    "en": {
        "url": "female-balance-iv-drip",
        "meta": {
            "title": "Female Balance IV Drip in Dubai - Elite Body Home",
            "description": "Support your hormonal balance and well-being with our Female Balance IV Drip in Dubai. This specialized therapy delivers essential nutrients directly to your bloodstream for optimal hormonal balance and overall wellness.",
            "robots": "follow, index, max-snippet:-1, max-video-preview:-1, max-image-preview:large",
            "canonical": "https://elitebodyhome.com/services/female-balance-iv-drip-in-dubai/",
            "og": {
                "locale": "en_US",
                "type": "article",
                "title": "Female Balance IV Drip in Dubai - Elite Body Home",
                "description": "Support your hormonal balance and well-being with our Female Balance IV Drip in Dubai. This specialized therapy delivers essential nutrients directly to your bloodstream.",
                "url": "https://elitebodyhome.com/services/female-balance-iv-drip-in-dubai/",
                "site_name": "elitebodyhome.com",
                "updated_time": "2025-01-23T09:27:39+00:00",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/female-balance-iv.jpg",
                "image_secure_url": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/female-balance-iv.jpg",
                "image_width": 1254,
                "image_height": 700,
                "image_alt": "Female Balance IV Drip Treatment in Dubai",
                "image_type": "image/jpeg"
            },
            "twitter": {
                "card": "summary_large_image",
                "title": "Female Balance IV Drip in Dubai - Elite Body Home",
                "description": "Support your hormonal balance and well-being with our Female Balance IV Drip in Dubai. This specialized therapy delivers essential nutrients directly to your bloodstream.",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/female-balance-iv.jpg"
            }
        },
        "breadcrumbs": ["Home", "Services", "Female Balance IV Drip"],
        "hero": {
            "title": "Female Balance IV Drip in Dubai",
            "subtitle": "Balance, Revitalize, and Thrive!",
            "description": "It's important to note that the female balance IV drip is not a general multivitamin, as it contains higher doses of nutrients to provide therapy and support hormonal balance and well-being. As women of all ages go through hormonal fluctuations, it can affect both physical and emotional health, which can cause mood swings, fatigue, irregular periods and so on. Dehydration can be caused by excessive sweating and heavy menstrual cycles, making hydration essential during this time and the Female Balance IV Drip is uniquely formulated with nutrients that will provide rapid and effective results far better than oral supplementation."
        },
        "howItWorks": {
            "title": "What is Female Balance IV Therapy?",
            "description": "Female Balance IV therapy is a specialized treatment designed to support your hormonal balance and overall well-being. The IV solution contains a powerful blend of B-complex vitamins, B12, minerals (magnesium, calcium), and antioxidants that work synergistically to enhance hormonal balance, promote emotional stability, and restore optimal health."
        },
        "procedureSteps": {
            "heading": "Female Balance IV Drip Procedure",
            "para": "This simple outpatient procedure delivers balancing nutrients directly into your bloodstream for maximum absorption and effectiveness.",
            "steps": [
                {
                    "title": "Consultation",
                    "desc": "A consultation will take place before the treatment, during which your health, lifestyle and symptoms will be assessed. This will help determine if the Female Balance IV Drip is appropriate for you.",
                    "icon": "fa-solid fa-comment-medical"
                },
                {
                    "title": "IV Preparation",
                    "desc": "The drip is a custom blend of vitamins (B-complex, B12), minerals (magnesium, calcium), and antioxidants formulated to support hormones and energy levels.",
                    "icon": "fa-solid fa-flask"
                },
                {
                    "title": "Administration",
                    "desc": "The IV goes into a vein and the nutrients are gradually released into your blood system.",
                    "icon": "fa-solid fa-syringe"
                },
                {
                    "title": "Relaxation",
                    "desc": "You relax while the infusion does its work during the 30 to 60 minute session.",
                    "icon": "fa-solid fa-heart-pulse"
                }
            ]
        },
        "benefits": {
            "heading": "Benefits of Female Balance IV Drip",
            "subheading": "Experience comprehensive hormonal support and balance",
            "para": "Our Female Balance IV therapy promotes overall wellness by enhancing your hormonal balance and providing essential nutrients directly to your bloodstream.",
            "items": [
                {
                    "title": "Hormonal Balance",
                    "desc": "Helps bring estrogen and progesterone levels into balance, alleviating symptoms like PMS, irregular cycles, and mood swings.",
                    "icon": "fa-solid fa-recycle"
                },
                {
                    "title": "Increased Energy Levels",
                    "desc": "Restores essential nutrients commonly lost in hormonal upheavals, resulting in enhanced vigor and energy.",
                    "icon": "fa-solid fa-bolt"
                },
                {
                    "title": "Reduced Fatigue & Brain Fog",
                    "desc": "Elevates mental fog and lessens tiredness making you feel more attentive and awake.",
                    "icon": "fa-solid fa-spa"
                },
                {
                    "title": "Improved Skin Health",
                    "desc": "Helps with clearer skin; can help decrease hormonal acne due to balanced hormones and antioxidants that aid in oxidative stress.",
                    "icon": "fa-solid fa-fire-extinguisher"
                }
            ]
        },
        "ingredients": {
            "heading": "Key Ingredients",
            "subheading": "Powerful nutrients for hormonal support and balance",
            "para": "Our Female Balance IV formula contains scientifically-proven ingredients to support women's health:",
            "items": [
                {
                    "title": "B-Complex Vitamins",
                    "desc": "Essential for energy production and nervous system function during hormonal changes.",
                    "icon": "fa-solid fa-shield-virus"
                },
                {
                    "title": "Vitamin B12",
                    "desc": "Supports red blood cell formation and helps combat fatigue associated with hormonal imbalances.",
                    "icon": "fa-solid fa-brain"
                },
                {
                    "title": "Magnesium",
                    "desc": "Helps regulate hormones and supports muscle relaxation and stress reduction.",
                    "icon": "fa-solid fa-atom"
                },
                {
                    "title": "Calcium",
                    "desc": "Important for bone health and helps with hormonal regulation.",
                    "icon": "fa-solid fa-shield-halved"
                }
            ]
        },
        "eligibility": {
            "heading": "Who Can Benefit?",
            "subheading": "Ideal candidates for Female Balance IV Therapy",
            "para": "Female Balance IV therapy is safe and effective for most women, especially beneficial for those experiencing:",
            "items": [
                {
                    "title": "Hormonal Symptoms",
                    "desc": "Women with irregular periods, PMS, mood swings or fatigue.",
                    "icon": "fa-solid fa-cloud"
                },
                {
                    "title": "Stress & Fatigue",
                    "desc": "Those seeking to restore energy and de-stress in a natural way.",
                    "icon": "fa-solid fa-biohazard"
                },
                {
                    "title": "Menopausal Symptoms",
                    "desc": "Women experiencing hot flashes or night sweats.",
                    "icon": "fa-solid fa-utensils"
                },
                {
                    "title": "Skin Concerns",
                    "desc": "Those suffering from hormonal acne or dull skin.",
                    "icon": "fa-solid fa-face-smile"
                }
            ]
        },
        "preparationTips": {
            "heading": "Preparation Guidelines",
            "subheading": "How to prepare for your Female Balance IV session",
            "para": "Follow these simple steps to maximize the benefits of your treatment:",
            "items": [
                {
                    "title": "Hydrate Well",
                    "desc": "Be well hydrated before your session to have best results on nutrient absorption.",
                    "icon": "fa-solid fa-glass-water"
                },
                {
                    "title": "Eat a Light Meal",
                    "desc": "Eating a small meal beforehand will help keep your blood sugar levels stable during your infusion.",
                    "icon": "fa-solid fa-apple-whole"
                },
                {
                    "title": "Avoid Caffeine & Alcohol",
                    "desc": "These can dehydrate you, inhibiting the IV drip from being effective.",
                    "icon": "fa-solid fa-ban"
                },
                {
                    "title": "Medical Disclosure",
                    "desc": "Inform your practitioner if you're pregnant or breastfeeding, as this treatment is contraindicated in these cases.",
                    "icon": "fa-solid fa-file-medical"
                }
            ]
        },
        "results": {
            "heading": "Expected Results",
            "subheading": "What to expect after your Female Balance IV Drip",
            "para": "Patients typically experience multiple health benefits from this targeted therapy:",
            "items": [
                {
                    "title": "Improved Mood",
                    "desc": "Women commonly report fewer mood swings and a greater sense of emotional balance.",
                    "icon": "fa-solid fa-battery-full"
                },
                {
                    "title": "Energy Boost",
                    "desc": "You might feel more zest in your step and less fatigue within hours of the treatment.",
                    "icon": "fa-solid fa-spa"
                },
                {
                    "title": "Clearer Skin",
                    "desc": "Hormonal acne and other skin concerns may improve with balanced hormones.",
                    "icon": "fa-solid fa-stomach"
                },
                {
                    "title": "Overall Wellbeing",
                    "desc": "With frequent therapies, you can maintain hormonal balance, improve your health, and feel better overall.",
                    "icon": "fa-solid fa-heart-circle-plus"
                }
            ]
        },
        "faqData": {
            "heading": "Frequently Asked Questions",
            "subheading": "Common questions about Female Balance IV Therapy",
            "items": [
                {
                    "question": "How often should I get a Female Balance IV Drip?",
                    "answer": "For optimal results, we recommend starting with 1-2 sessions per month, adjusting based on your symptoms and needs. Your practitioner will customize a plan for you."
                },
                {
                    "question": "Is the treatment painful?",
                    "answer": "Most patients experience minimal discomfort - just a small pinch during IV insertion. The treatment itself is relaxing and pain-free."
                },
                {
                    "question": "How quickly will I see results?",
                    "answer": "Many patients report feeling more balanced and energetic within hours to days after treatment."
                },
                {
                    "question": "Are there any side effects?",
                    "answer": "Side effects are rare but may include mild bruising at the injection site. The treatment is generally well-tolerated."
                },
                {
                    "question": "Can I combine this with other hormonal treatments?",
                    "answer": "Yes, our Female Balance IV complements other hormonal approaches. We can create a comprehensive plan tailored to your needs."
                },
                {
                    "question": "Is this treatment safe for everyone?",
                    "answer": "While generally safe, we recommend consulting with our medical team if you have severe medical conditions or are pregnant/breastfeeding."
                }
            ]
        }
    },
    "ar": {
        "url": "female-balance-iv-drip",
        "meta": {
            "title": "علاج التنقيط الوريدي للتوازن الهرموني للنساء في دبي | إيليت بودي هوم",
            "description": "دعم التوازن الهرموني وصحة المرأة مع علاج التنقيط الوريدي للتوازن الهرموني للنساء في دبي. يوفر هذا العلاج المتخصص العناصر الغذائية الأساسية مباشرة إلى مجرى الدم لتحقيق التوازن الهرموني والصحة العامة.",
            "robots": "index, follow",
            "canonical": "https://elitebodyhome.com/services/female-balance-iv-drip-in-dubai/",
            "og": {
                "title": "علاج التنقيط الوريدي للتوازن الهرموني للنساء في دبي | إيليت بودي هوم",
                "description": "دعم التوازن الهرموني وصحة المرأة مع علاج التنقيط الوريدي للتوازن الهرموني للنساء في دبي. يوفر هذا العلاج المتخصص العناصر الغذائية الأساسية مباشرة إلى مجرى الدم.",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/female-balance-iv.jpg"
            }
        },
        "breadcrumbs": ["الرئيسية", "الخدمات", "التنقيط الوريدي للتوازن الهرموني للنساء"],
        "hero": {
            "title": "علاج التنقيط الوريدي للتوازن الهرموني للنساء في دبي",
            "subtitle": "استعيدي توازنك الهرموني وحيويتك!",
            "description": "يجب توضيح أن هذا العلاج الوريدي ليس مجرد مجموعة من الفيتامينات الوريدية العامة، بل يحتوي على جرعات مركزة من العناصر الغذائية التي تهدف إلى تقديم علاج فعال ودعم التوازن الهرموني وصحة المرأة. تمر النساء من مختلف الأعمار بتغيرات هرمونية تؤثر على الصحة الجسدية والنفسية، مما قد يؤدي إلى تقلبات الحالة المزاجية، والإرهاق، وعدم انتظام الدورة الشهرية وغيرها من الأعراض. ويُعد الترطيب أمرًا بالغ الأهمية، خاصة مع التعرق الشديد أو النزيف الغزير أثناء الدورة الشهرية، ما يجعل التنقيط الوريدي للتوازن الهرموني الأنثوي خيارًا مثاليًا. حيث صُمم خصيصًا ليزود الجسم بالعناصر الغذائية الضرورية بطريقة سريعة وفعالة، ويتفوق في نتائجه على المكملات الغذائية التي تؤخذ عن طريق الفم."
        },
        "howItWorks": {
            "title": "ما هو علاج التنقيط الوريدي للتوازن الهرموني؟",
            "description": "علاج التنقيط الوريدي للتوازن الهرموني هو علاج متخصص مصمم لدعم التوازن الهرموني والصحة العامة للمرأة. يحتوي المحلول الوريدي على مزيج قوي من فيتامينات ب المركبة، فيتامين ب12، المعادن (المغنيسيوم، الكالسيوم)، ومضادات الأكسدة التي تعمل معًا لتعزيز التوازن الهرموني، وتحسين الاستقرار العاطفي، واستعادة الصحة المثلى."
        },
        "procedureSteps": {
            "heading": "خطوات علاج التنقيط الوريدي للتوازن الهرموني",
            "para": "هذا الإجراء البسيط في العيادات الخارجية يوفر العناصر الغذائية الموزونة مباشرة في مجرى الدم لأقصى امتصاص وفعالية.",
            "steps": [
                {
                    "title": "الاستشارة",
                    "desc": "تُجرى استشارة لتقييم حالتك الصحية، وأسلوب حياتك، والأعراض التي تعانين منها قبل بدء الجلسة. يساعد هذا التقييم في تحديد مدى ملاءمة هذا العلاج لك.",
                    "icon": "fa-solid fa-comment-medical"
                },
                {
                    "title": "تحضير المحلول",
                    "desc": "يحتوي المحلول على مزيج مُخصص من الفيتامينات، مثل فيتامين ب المركب وفيتامين ب 12، والمعادن، مثل المغنيسيوم والكالسيوم، إلى جانب مضادات الأكسدة، بهدف دعم التوازن الهرموني وتعزيز الطاقة.",
                    "icon": "fa-solid fa-flask"
                },
                {
                    "title": "التنفيذ",
                    "desc": "تُدخل إبرة وريدية صغير في أحد أوردة الذراع، ويتم ضخ المحلول تدريجيًا إلى مجرى الدم.",
                    "icon": "fa-solid fa-syringe"
                },
                {
                    "title": "الاسترخاء",
                    "desc": "يمكنك الاسترخاء خلال الجلسة بينما يقوم المحلول بدوره في تنشيط الجسم وتحقيق التوازن خلال الجلسة التي تستغرق من 30 إلى 60 دقيقة.",
                    "icon": "fa-solid fa-heart-pulse"
                }
            ]
        },
        "benefits": {
            "heading": "فوائد التنقيط الوريدي للتوازن الهرموني",
            "subheading": "استفيدي من الدعم الشامل للتوازن الهرموني",
            "para": "يعزز علاجنا الوريدي للتوازن الهرموني الصحة العامة من خلال تحسين التوازن الهرموني وتوفير العناصر الغذائية الأساسية مباشرة إلى مجرى الدم.",
            "items": [
                {
                    "title": "استعادة التوازن الهرموني",
                    "desc": "يساعد على إعادة توازن مستويات هرموني الإستروجين والبروجستيرون، مما يخفف من أعراض مثل أعراض متلازمة ما قبل الحيض (PMS)، وعدم انتظام الدورة الشهرية، وتقلبات المزاج.",
                    "icon": "fa-solid fa-recycle"
                },
                {
                    "title": "زيادة مستويات الطاقة",
                    "desc": "يُعوض الجسم بالعناصر الغذائية المفقودة نتيجة التقلبات الهرمونية، مما يؤدي إلى استعادة النشاط والحيوية.",
                    "icon": "fa-solid fa-bolt"
                },
                {
                    "title": "تقليل الإرهاق والتشوش الذهني",
                    "desc": "يعمل على تحسين الصفاء الذهني وتقليل الشعور بالتعب، مما يمنح المرأة شعورًا باليقظة والتركيز.",
                    "icon": "fa-solid fa-spa"
                },
                {
                    "title": "تحسين صحة البشرة",
                    "desc": "يساهم في تحسين نقاء البشرة وصحة الجلد وتخفيف حب الشباب الهرموني بفضل استقرار الهرمونات واحتواءه على مضادات الأكسدة التي تحارب الإجهاد التأكسدي.",
                    "icon": "fa-solid fa-fire-extinguisher"
                }
            ]
        },
        "ingredients": {
            "heading": "المكونات الرئيسية",
            "subheading": "عناصر غذائية قوية لدعم التوازن الهرموني",
            "para": "تحتوي تركيبتنا الوريدية للتوازن الهرموني على مكونات مثبتة علميًا لدعم صحة المرأة:",
            "items": [
                {
                    "title": "فيتامينات ب المركبة",
                    "desc": "ضرورية لإنتاج الطاقة ووظيفة الجهاز العصبي خلال التغيرات الهرمونية.",
                    "icon": "fa-solid fa-shield-virus"
                },
                {
                    "title": "فيتامين ب12",
                    "desc": "يدعم تكوين خلايا الدم الحمراء ويساعد في مكافحة التعب المرتبط باختلال التوازن الهرموني.",
                    "icon": "fa-solid fa-brain"
                },
                {
                    "title": "المغنيسيوم",
                    "desc": "يساعد في تنظيم الهرمونات ويدعم استرخاء العضلات وتقليل التوتر.",
                    "icon": "fa-solid fa-atom"
                },
                {
                    "title": "الكالسيوم",
                    "desc": "مهم لصحة العظام ويساعد في تنظيم الهرمونات.",
                    "icon": "fa-solid fa-shield-halved"
                }
            ]
        },
        "eligibility": {
            "heading": "من يمكنها الاستفادة؟",
            "subheading": "المرشحات المثاليات لعلاج التنقيط الوريدي للتوازن الهرموني",
            "para": "علاج التنقيط الوريدي للتوازن الهرموني آمن وفعال لمعظم النساء، وخاصة المفيد لمن يعانين من:",
            "items": [
                {
                    "title": "أعراض هرمونية",
                    "desc": "النساء اللواتي يعانين من عدم انتظام الدورة الشهرية، أو متلازمة ما قبل الحيض، أو تقلبات الحالة المزاجية أو الإرهاق المزمن.",
                    "icon": "fa-solid fa-cloud"
                },
                {
                    "title": "التوتر والإرهاق",
                    "desc": "اللواتي يبحثن عن طريقة طبيعية لاستعادة الطاقة والتخلص من التوتر والإجهاد.",
                    "icon": "fa-solid fa-biohazard"
                },
                {
                    "title": "أعراض انقطاع الطمث",
                    "desc": "النساء اللواتي يعانين من الهبات الساخنة أو التعرق الليلي.",
                    "icon": "fa-solid fa-utensils"
                },
                {
                    "title": "مشاكل البشرة",
                    "desc": "اللواتي يعانين من حب الشباب الهرموني أو شحوب البشرة.",
                    "icon": "fa-solid fa-face-smile"
                }
            ]
        },
        "preparationTips": {
            "heading": "إرشادات التحضير",
            "subheading": "كيف تستعدين لجلسة العلاج الوريدي للتوازن الهرموني",
            "para": "اتبعي هذه الخطوات البسيطة لتعظيم فوائد علاجك:",
            "items": [
                {
                    "title": "حافظي على الترطيب",
                    "desc": "احرصي على شرب كميات كافية من الماء قبل الجلسة، حيث يُساعد الترطيب الجيد على تحسين امتصاص العناصر الغذائية داخل الجسم.",
                    "icon": "fa-solid fa-glass-water"
                },
                {
                    "title": "تناولي وجبة خفيفة",
                    "desc": "يُفضل تناول وجبة خفيفة قبل الجلسة، لضمان استقرار مستويات السكر في الدم أثناء الجلسة.",
                    "icon": "fa-solid fa-apple-whole"
                },
                {
                    "title": "تجنبي الكافيين والكحول",
                    "desc": "ينصح بتجنب الكافيين والمشروبات الكحولية قبل الجلسة، لأنها قد تؤدي إلى الجفاف وتقلل من فاعلية العلاج.",
                    "icon": "fa-solid fa-ban"
                },
                {
                    "title": "الكشف الطبي",
                    "desc": "أخبري الطبيب إذا كنتِ حاملاً أو مرضعة، حيث يُمنع استخدام هذا العلاج خلال هذه الفترات.",
                    "icon": "fa-solid fa-file-medical"
                }
            ]
        },
        "results": {
            "heading": "النتائج المتوقعة",
            "subheading": "ما يمكن توقعه بعد جلسة التنقيط الوريدي للتوازن الهرموني",
            "para": "تشعر المريضات عادةً بفوائد صحية متعددة من هذا العلاج المستهدف:",
            "items": [
                {
                    "title": "تحسن الحالة المزاجية",
                    "desc": "تقل التقلبات المزاجية والشعور بالتوتر، مما يمنحك إحساساً بالهدوء النفسي.",
                    "icon": "fa-solid fa-battery-full"
                },
                {
                    "title": "زيادة الطاقة",
                    "desc": "ستشعرين بزيادة في الحيوية وتراجع الشعور بالإرهاق خلال ساعات قليلة من الجلسة.",
                    "icon": "fa-solid fa-spa"
                },
                {
                    "title": "بشرة أكثر نقاءً",
                    "desc": "قد يساهم العلاج في تقليل حب الشباب الهرموني مع الاستمرار في الجلسات.",
                    "icon": "fa-solid fa-stomach"
                },
                {
                    "title": "تحسن عام في الصحة",
                    "desc": "يمكنكِ الحفاظ على التوازن الهرموني، وتحسين صحتكِ العامة، والشعور بالراحة والاستقرار على المدى الطويل مع الاستمرار في العلاج.",
                    "icon": "fa-solid fa-heart-circle-plus"
                }
            ]
        },
        "faqData": {
            "heading": "الأسئلة الشائعة",
            "subheading": "أسئلة متداولة حول العلاج الوريدي للتوازن الهرموني",
            "items": [
                {
                    "question": "كم مرة يجب أن أحصل على جلسة التنقيط الوريدي للتوازن الهرموني؟",
                    "answer": "للحصول على أفضل النتائج، نوصي بالبدء بجلسة إلى جلستين شهريًا، مع التعديل بناءً على الأعراض والاحتياجات. سيخصص لك الممارس خطة علاجية مناسبة."
                },
                {
                    "question": "هل العلاج مؤلم؟",
                    "answer": "تشعر معظم المريضات بعدم ارتياح بسيط - مجرد وخزة صغيرة أثناء إدخال الوريد. العلاج نفسه مريح وخالٍ من الألم."
                },
                {
                    "question": "ما هي سرعة ظهور النتائج؟",
                    "answer": "تبلغ العديد من المريضات عن شعورهن بمزيد من التوازن والطاقة خلال ساعات إلى أيام بعد العلاج."
                },
                {
                    "question": "هل هناك أي آثار جانبية؟",
                    "answer": "الآثار الجانبية نادرة ولكن قد تشمل كدمات طفيفة في موقع الحقن. العلاج بشكل عام جيد التحمل."
                },
                {
                    "question": "هل يمكنني الجمع بين هذا العلاج والعلاجات الهرمونية الأخرى؟",
                    "answer": "نعم، يتكامل علاجنا الوريدي مع الأساليب الهرمونية الأخرى. يمكننا وضع خطة شاملة مخصصة لاحتياجاتك."
                },
                {
                    "question": "هل هذا العلاج آمن للجميع؟",
                    "answer": "بينما يعتبر آمنًا بشكل عام، نوصي باستشارة فريقنا الطبي إذا كنت تعانين من حالات طبية شديدة أو كنت حاملاً/مرضعة."
                }
            ]
        }
    },
    "shared": {
        "images": {
            "main": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/New-Service-Banner-cfdgImage-1-scaled.jpg",
            "beforeAfter": []
        },
        "product": {
            "id": 9,
            "title": "Female Balance IV Drip Treatment",
            "description": "Specialized intravenous therapy delivering hormone-balancing nutrients directly to your bloodstream for enhanced hormonal balance and improved well-being.",
            "price": 599
        }
    }
}